module.exports = __webpack_public_path__ + "487a67cc538f0c41eada91a3e52f944f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-account/owner/manage-account-owner.html
// module id = 2079
// module chunks = 0